class VariantSelector {
  constructor() {
   
    this.variantRadios = document.querySelectorAll('variant-radios');

    this.initialize();
  }

  initialize() {
    this.variantRadios.forEach((radioGroup, index) => {
   
      
      // Watch for changes on the color radio buttons
      const colorRadios = radioGroup.querySelectorAll('input[name="Colour"]');
     
      
      if (colorRadios.length) {
        colorRadios.forEach(radio => {
          radio.addEventListener('change', (event) => {
           
            this.handleColorChange(event, radioGroup);
          });
        });
      } else {
        console.warn(`No color radios found for variant ${index + 1}`);
      }

      // Watch for changes on size radio buttons
      const sizeRadios = radioGroup.querySelectorAll('input[name="Size"]');
      if (sizeRadios.length) {
        sizeRadios.forEach(radio => {
          radio.addEventListener('change', (event) => {
        
            this.updateSizeButton(radioGroup);
          });
        });
      }
    });
  }

  handleColorChange(event, radioGroup) {
  
    const sizeRadios = radioGroup.querySelectorAll('input[name="Size"]');
   
    
    if (!sizeRadios.length) {
    
      return;
    }

    // Get currently selected size
    const currentSizeRadio = radioGroup.querySelector('input[name="Size"]:checked');
    if (!currentSizeRadio) {
      console.warn('No size currently selected');
      return;
    }

    

    // Check if current size is available for new color
    const currentVariant = this.getVariantFromOption(currentSizeRadio, radioGroup);
 

    if (currentVariant && currentVariant.available) {
    
      this.updateSizeButton(radioGroup);
      return;
    }

    // If current size is not available, find first available size
    const sizeOptions = Array.from(sizeRadios);
 
    
    const availableSize = sizeOptions.find(radio => {
      const variant = this.getVariantFromOption(radio, radioGroup);
  
      return variant && variant.available;
    });



    if (availableSize) {
    
      // Set the first available size as selected
      availableSize.checked = true;
      // Trigger change event to update the UI
      availableSize.dispatchEvent(new Event('change'));
      
      // Update the product form
      this.updateProductForm(radioGroup);
      this.updateSizeButton(radioGroup);
    } else {
      console.warn('No available sizes found');
    }
  }

  updateSizeButton(radioGroup) {
    const sizeButton = radioGroup.querySelector('.size-label-action');
    if (!sizeButton) {
   
      return;
    }

    const selectedSize = radioGroup.querySelector('input[name="Size"]:checked');
    if (!selectedSize) {
  
      return;
    }

    const sizeValue = selectedSize.value;
    const sizeValueSpan = sizeButton.querySelector('.value');
    if (sizeValueSpan) {
      sizeValueSpan.textContent = sizeValue;
    }
  }

  updateProductForm(radioGroup) {
   
    const form = radioGroup.closest('form');
    if (!form) {
      console.warn('No form found');
      return;
    }

    // Get the variant ID from the selected options
    const colorRadio = radioGroup.querySelector('input[name="Colour"]:checked');
    const sizeRadio = radioGroup.querySelector('input[name="Size"]:checked');
    
    if (!colorRadio || !sizeRadio) {
      console.warn('Missing color or size selection');
      return;
    }

    const variant = this.getVariantFromOption(sizeRadio, radioGroup);
    if (!variant) {
      console.warn('No variant found for selected options');
      return;
    }

 

    // Update the variant ID input
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change'));
    }

    // Update the variant title display
    const variantTitle = form.querySelector('.variant-title');
    if (variantTitle) {
      variantTitle.textContent = `${colorRadio.value} / ${sizeRadio.value}`;
    }

    // Update any other variant-dependent elements
    const priceElement = form.querySelector('.price');
    if (priceElement) {
      priceElement.textContent = `$${(variant.price / 100).toFixed(2)}`;
    }
  }

  getVariantFromOption(radio, radioGroup) {
   
    
    const variantDataElement = radioGroup.querySelector('script[type="application/json"]');
    
    
    if (!variantDataElement) {
      console.error('ProductVariants element not found');
      return null;
    }

    let variantData;
    try {
      variantData = JSON.parse(variantDataElement.textContent);
 
    } catch (error) {
      console.error('Error parsing variant data:', error);
      return null;
    }

    const colorRadio = radioGroup.querySelector('input[name="Colour"]:checked');
    const selectedColor = colorRadio ? colorRadio.value : '';

    
    const variant = variantData.find(variant => {
      const variantColor = variant.option1 === selectedColor || variant.option2 === selectedColor;
      const variantSize = variant.option1 === radio.value || variant.option2 === radio.value;
      console.log(`Checking variant:`, {
        variant,
        variantColor,
        variantSize,
        matches: variantColor && variantSize
      });
      return variantColor && variantSize;
    });

    console.log('Found matching variant:', variant);
    return variant;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {

  new VariantSelector();
});

// Also try to initialize immediately in case DOMContentLoaded already fired
if (document.readyState === 'complete' || document.readyState === 'interactive') {

  new VariantSelector();
} 